// noinspection ES6MissingAwait,JSIgnoredPromiseFromCall

import Sweet from 'sweetalert2'

export const MessageDictionary = {
    AWAIT: 'Aguarde...',
    DUPLICATED_EMAIL: 'O e-mail informado já existe. Faça login em JÁ SOU CADASTRADO para continuar com a compra.',
    INVALID_CEP: 'Informe um CEP válido.',
    INVALID_COUPON: 'Cupom inválido.',
    INVALID_CPF: 'Informe um CPF válido.',
    INVALID_DATE: 'Informe uma data válida.',
    INVALID_EMAIL: 'Informe um e-mail válido.',
    INVALID_LOGIN: 'Usuário ou senha inválidos.',
    INVALID_PASSWORD: 'As senhas informadas não conferem.',
    INVALID_PAYMENT: 'Método de pagamento inválido',
    INVALID_PHONE: 'Informe um telefone válido.',
    PAYMENT_FAIL: 'Não foi possível realizar o pagamento.',
    TOO_MANY_REQUESTS: 'Você excedeu o limite de solicitações e foi bloqueado. Entre em contato com o suporte.',
    TRY_AGAIN: 'Verifique os seus dados e tente novamente.',
    UNEXPECTED_ERROR: 'Erro inesperado, tente novamente. Se o problema persistir entre em contato com o suporte.',
}

export const checkValidity = (form) => {
    return Array.from(form.querySelectorAll('input, .form-control')).every((element) => {
        if (element.nodeName === 'DIV') return true
        return element.checkValidity()
    })
}

export const phoneValidation = (phone) => {
    phone = phone.replace(/\D/g, '')

    if (!(phone.length >= 10 && phone.length <= 11)) return false

    if (phone.length === 11 && parseInt(phone.substring(2, 3)) !== 9) return false

    for (let n = 0; n < 10; n++) {
        if (phone === new Array(11).join(String(n)) || phone === new Array(12).join(String(n))) return false
    }

    const validDDD = [
        11, 12, 13, 14, 15, 16, 17, 18, 19,
        21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46,
        47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73,
        74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95,
        96, 97, 98, 99,
    ]

    if (validDDD.indexOf(parseInt(phone.substring(0, 2))) === -1) return false

    return !(phone.length === 10 && [2, 3, 4, 5, 7].indexOf(parseInt(phone.substring(2, 3))) === -1)
}

export const formSubmit = (event) => {
    event.preventDefault()
    const form = event.target
    const button = form.elements.submit
    const buttonText = button.innerHTML
    button.setAttribute('disabled', true)
    button.innerHTML = MessageDictionary.AWAIT
    form.classList.add('was-validated')

    if (!checkValidity(form)) {
        event.stopPropagation()
        $('#formToast').toast('show')
        button.removeAttribute('disabled')
        button.innerHTML = buttonText
        return
    }

    return { form, button, buttonText }
}

export const errorMessage = (error) => {
    if (!Object.values(MessageDictionary).includes(error)) error = MessageDictionary.UNEXPECTED_ERROR

    Sweet.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.message || error,
    })
}

export const fetchCustom = async (url, options = {}, defaultErrorMessage = MessageDictionary.UNEXPECTED_ERROR) => {
    let body = options.body;
    const noAuth = options.noAuth || false;
    if (options.noAuth) delete options.noAuth;

    if (!['string', 'number'].includes(typeof body)) {
        body = JSON.stringify(body || {})
    }

    const data = await fetch(url, {
        ...options,
        ...(options.body && { body }),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...(!noAuth && {
                'Authorization': `Bearer ${process.env.MIX_API_ACCESS_TOKEN}`,
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
            ...options.headers,
        },
    }).catch(() => {
        throw defaultErrorMessage
    })

    if (!data.ok) {
        if (data.statusCode === 429) {
            throw MessageDictionary.TOO_MANY_REQUESTS
        }

        throw defaultErrorMessage
    }

    return await data.json().catch(() => {
        throw defaultErrorMessage
    })
}

export const getCookie = (cname) => {
    const name = cname + '='
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]

        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }

        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }

    return ''
}

export const copyToClipboard = async (textToCopy) => {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
    } else {
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;

        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
            // noinspection JSDeprecatedSymbols
            document.execCommand('copy');
        } catch (error) {
            console.error(error);
        } finally {
            textArea.remove();
        }
    }
}
